import PropTypes from 'prop-types';

import './AssetsDropFilesIndicatorBox.scss';

import uploadWitheArrowIcon
	from '../../../assets/img/icons/upload-white-arrow-icon.svg';
import errorOutlineIcon
	from '../../../assets/img/icons/error-outline.svg';
import { fileNameTextTruncate } from '../../../lib/textTruncate';

const NewRoundIndicatorText = ( { assetName } ) => (
	<>
		<h1> Upload new round of {fileNameTextTruncate( assetName, 25, 30 )}</h1>
		<p>Drop a new asset here. You can upload only 1 file.</p>
	</>
);

NewRoundIndicatorText.propTypes = {
	assetName: PropTypes.string.isRequired
};

const NewAssetIndicatorText = ( { projectName, folderName } ) => (
	<>
		<h1>Upload to “{folderName || projectName}”</h1>
		<p>Drop your assets or documents here.</p>
	</>
);

NewAssetIndicatorText.propTypes = {
	projectName: PropTypes.string.isRequired,
	folderName: PropTypes.string
};

NewAssetIndicatorText.defaultProps = {
	folderName: undefined
};

const PermissionDeniedInfo = () => (
	<>
		<img src={errorOutlineIcon} alt="not allowed" />
		<h1>Upload Not Allowed</h1>
		<p>
			Your role doesn&apos;t include permissions to upload assets.
			If you need to add files to the project, contact the Project Owner.
		</p>
	</>
);

const UploadInstructionsInfo = ( { uploadingRoundForAsset, assetName, projectName, folderName } ) => (
	<>
		<img src={uploadWitheArrowIcon} alt="upload" />
		{uploadingRoundForAsset && assetName
			? <NewRoundIndicatorText assetName={assetName} />
			: <NewAssetIndicatorText projectName={projectName} folderName={folderName} />}
		<p className="extensions-suggestion">
			Some valid extensions are: <br /> jpeg, png, tiff, pdf, psd.
		</p>
	</>
);

const AssetsDropFilesIndicatorBox = ( {
	projectName, folderName, assetName, uploadingRoundForAsset, currentUserCanUploadAssets
} ) => (
	<div className="AssetsDropFilesIndicatorBox">
		<div className="drop-files-message">
			{currentUserCanUploadAssets
				? (
					<UploadInstructionsInfo
						uploadingRoundForAsset={uploadingRoundForAsset}
						assetName={assetName}
						projectName={projectName}
						folderName={folderName}
					/>
				)
				: <PermissionDeniedInfo />}
		</div>
	</div>
);

PermissionDeniedInfo.propTypes = {};

UploadInstructionsInfo.propTypes = {
	uploadingRoundForAsset: PropTypes.bool,
	assetName: PropTypes.string,
	projectName: PropTypes.string.isRequired,
	folderName: PropTypes.string
};

AssetsDropFilesIndicatorBox.propTypes = {
	projectName: PropTypes.string.isRequired,
	folderName: PropTypes.string,
	assetName: PropTypes.string,
	uploadingRoundForAsset: PropTypes.bool,
	currentUserCanUploadAssets: PropTypes.bool
};

AssetsDropFilesIndicatorBox.defaultProps = {
	folderName: undefined,
	assetName: undefined,
	uploadingRoundForAsset: false,
	currentUserCanUploadAssets: true
};

export default AssetsDropFilesIndicatorBox;
